import { useEffect, useState } from 'react'
import { Header } from 'components/layout/header'
import { Main } from 'components/layout/main'
import { Search } from 'components/search'
import { GenericDataTable } from 'helpers/generic-data-table'
import { reportsColumns } from 'helpers/reports-columns'
import {
  deleteTarget,
  fetchReports,
  updateReport,
} from 'store/reports/reportsSlice'
import { useAppDispatch, useAppSelector } from 'store/store'

const ReportsPage = () => {
  const dispatch = useAppDispatch()
  const { totalPages, reports } = useAppSelector((state) => state.reports)
  const [pageIndex, setPageIndex] = useState(0) // React Table uses 0-based index
  const pageSize = 20

  useEffect(() => {
    const fetchData = async () => {
      await dispatch(fetchReports(pageIndex + 1)) // Your API likely uses 1-based index
    }

    fetchData()
  }, [dispatch, pageIndex])

  return (
    <>
      {/* ===== Top Heading ===== */}
      <Header>
        <div className='ml-auto flex items-center space-x-4'>
          <Search />
        </div>
      </Header>

      {/* ===== Main ===== */}
      <Main>
        <div className='mb-2 flex flex-wrap items-center justify-between space-y-2 gap-x-4'>
          <div>
            <h2 className='text-2xl font-bold tracking-tight'>Segnalazioni</h2>
            <p className='text-muted-foreground'>
              Pagina di gestione segnalazioni degli utenti
            </p>
          </div>
        </div>
        <div className='-mx-4 mt-5 flex-1 overflow-auto px-4 py-1 lg:flex-row lg:space-y-0 lg:space-x-12'>
          <GenericDataTable
            columns={reportsColumns({
              onDeleteTarget: (id: number) => {
                dispatch(deleteTarget(id))
              },
              onUpdateReport: (id: number, admin_notes: string) => {
                dispatch(updateReport({ id, admin_notes }))
              },
            })}
            data={reports || []}
            pageCount={totalPages}
            pageIndex={pageIndex}
            pageSize={pageSize}
            onPageIndexChange={setPageIndex}
          />
        </div>
      </Main>
    </>
  )
}

export default ReportsPage
